import ClassicQuizBasicModel from "../ClassicQuizBasicModel";

export default class ClassicQuizUserRank {
  public position: number = null;
  public classicQuizId: string = null;
  public classicQuizModel: ClassicQuizBasicModel = null;
  public points: number = null;
}
